
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ModalRef {
  
  id!: number;

  /** Instance du composant modal */
  content: any;

  /** Events */
  onHide = new Subject<void>();
  onHidden = new Subject<void>();
  onShow = new Subject<void>();
  onShown = new Subject<void>();

  constructor(private _closeFn: () => void) {}

  hide(): void {
    this._closeFn();
  }
}